import { OpoOrganization } from '@/api/apis/opo';
import { SelectItemType } from '@/types';
import { OpoOrgMembershipForm } from './types';

type OpoOrgListItem = SelectItemType & { data?: OpoOrganization };

export const getCombinedOpoOrgList = (
  memberships: OpoOrgMembershipForm[] | undefined,
  infiniteDropdownList: OpoOrgListItem[],
): OpoOrgListItem[] => {
  if (!memberships?.length) {
    return infiniteDropdownList;
  }

  const selectedOrgs = memberships
    .map((m) =>
      m.opoOrganization
        ? ({ name: m.opoOrganization.name, value: m.opoOrganization.id, data: m.opoOrganization } as OpoOrgListItem)
        : null,
    )
    .filter((o): o is OpoOrgListItem => !!o);

  const filteredOrgs = infiniteDropdownList.filter((a) => !selectedOrgs.some((s) => s.value === a.value));

  return [...selectedOrgs, ...filteredOrgs];
};

export const getUpdatedMemberships = (
  selectedIDs: string[],
  currentMemberships: OpoOrgMembershipForm[],
  list: OpoOrgListItem[],
): OpoOrgMembershipForm[] => {
  return selectedIDs.map((opoOrganizationId) => {
    const existing = currentMemberships.find((m) => m.opoOrganizationId === opoOrganizationId);
    if (existing) {
      return existing;
    }
    const opoOrganization = list.find((t) => t.value === opoOrganizationId)?.data;
    return { opoOrganizationId, roles: [], opoOrganization };
  });
};

export const sortSelectedItems = (items: Array<{ data?: OpoOrgListItem | null }>): SelectItemType[] => {
  return [...items]
    .sort((a, b) => {
      const nameA = a.data?.name || '';
      const nameB = b.data?.name || '';
      return nameA.localeCompare(nameB);
    })
    .map((item) => item.data)
    .filter(Boolean) as SelectItemType[];
};
